/**
 * Pricing Options — the chooser that switches which price a plan shows.
 *
 * The options themselves live on the table, because the price block has to be
 * handed the same list to know how many rows to keep. This block owns how they
 * look, and edits the table's list through the parent — clicking the control
 * and finding its own contents in the sidebar is the whole point of it being a
 * block rather than a panel on the table.
 */
import { __ } from '@wordpress/i18n';
import { registerBlockType } from '@wordpress/blocks';

import metadata from './block.json';
import Edit from './Edit';
import './style.scss';

registerBlockType(metadata.name, {
  __experimentalLabel: () => __('Options', 'brandy-blocks'),

  icon: {
    foreground: '#0061FE',
    src: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
        <path d="M6 7.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Zm2.5-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm0 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM14 6.75h6v1.5h-6v-1.5ZM6 16.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Zm2.5-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8ZM14 15.75h6v1.5h-6v-1.5Z" />
      </svg>
    ),
  },

  edit: Edit,

  save: () => null,
});
